export default __webpack_public_path__ + "src/assets/google-play-badge.1ccb13129e116ea229734e47b8bfe550.png";